import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import StandardModule from './pages/StandardModule';
import YouthModule from './pages/YouthModule';
import SensibilisationModule from './pages/SensibilisationModule';
import LegalMentions from './pages/LegalMentions';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/module-standard" element={<StandardModule />} />
            <Route path="/module-jeune" element={<YouthModule />} />
            <Route path="/sensibilisation" element={<SensibilisationModule />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<LegalMentions />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
